import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Card from "@mui/material/Card";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { secureGetItem } from "../../../utils/encryption";
interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function CityMaster() {
  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });

  let navigate = useNavigate();
  const { t } = useTranslation();

useEffect(() => {
  const data = secureGetItem("userdata");   // ✅ decrypt + parse

  if (data && data.length > 0) {
    const userPermissionData = data[0]?.userPermission;
    const menudata = userPermissionData?.[0]?.parentMenu || [];

    for (let i = 0; i < menudata.length; i++) {
      const childMenudata = menudata[i]?.childMenu || [];
      const pathrow = childMenudata.find(
        (x: any) => x.path === location.pathname
      );

      if (pathrow) {
        setPermissionData({
          isAdd: pathrow.isAdd,
          isEdit: pathrow.isEdit,
          isPrint: pathrow.isPrint,
          isDel: pathrow.isDel,
        });
        break;
      }
    }
  }

  // fetchZonesData();
   setPermissionLoaded(true);   
}, [location.pathname]);
  // }, [isLoading]);
  const routeChangeAdd = () => {
    let path = `/master/CityMasterAdd`;
    navigate(path);
  };

  
  const routeChangeEdit = (row: any) => {
    let path = `/master/CityMasterEdit`;
    navigate(path, {
      state: row,
    });
  };

  let delete_id = "";

  const accept = () => {
    const collectData = {
      city_id: delete_id,
      state_id: 0,
    };
    console.log("collectData " + JSON.stringify(collectData));
    axios
      .post(HOST_URL.HOST_URL2 + `District/DeleteDistrictMaster`,  collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        fetchZonesData();
      });
  };

  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  useEffect(() => {
    if(permissionLoaded){
      fetchZonesData();
    }
 
}, [permissionLoaded]);   // ✅ jab permission change ho tab columns banao
  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const fetchZonesData = async () => {
    try {
      const collectData = {
        city_id: -1,
        state_id: -1,
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `District/GetDistrictMaster`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: emp.city_id,
      }));

      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const actionColumn: GridColDef[] =
  permissionData?.isEdit || permissionData?.isDel
    ? [
        {
          field: "actions",
          headerClassName: "MuiDataGrid-colCell",
          headerName: t("text.Action"),
          width: 150,
          renderCell: (params) => (
            <Stack spacing={1} direction="row" sx={{ alignItems: "center", marginTop: "5px" }}>
              {permissionData?.isEdit && (
                <EditIcon
                  style={{ fontSize: "20px", color: "blue", cursor: "pointer" }}
                  onClick={() => routeChangeEdit(params.row)}
                />
              )}

              {permissionData?.isDel && (
                <DeleteIcon
                  style={{ fontSize: "20px", color: "red", cursor: "pointer" }}
                  onClick={() => handledeleteClick(params.row.id)}
                />
              )}
            </Stack>
          ),
        },
      ]
    : [];
        const columns: GridColDef[] = 
        [
          ...actionColumn, 
          // {
          //   field: "actions",
          //   headerClassName: "MuiDataGrid-colCell",
          //   headerName: t("text.Action"),
          //   width: 150,

          //   renderCell: (params) => {
          //     return [
          //       <Stack
          //         spacing={1}
          //         direction="row"
          //         sx={{ alignItems: "center", marginTop: "5px" }}
          //       >
          //         {permissionData?.isEdit && (
          //         <EditIcon
          //           style={{
          //             fontSize: "20px",
          //             color: "blue",
          //             cursor: "pointer",
          //           }}
          //           className="cursor-pointer"
          //           onClick={() => routeChangeEdit(params.row)}
          //         />
              
          //         )} 
          //         {permissionData?.isDel && (
          //         <DeleteIcon
          //           style={{
          //             fontSize: "20px",
          //             color: "red",
          //             cursor: "pointer",
          //           }}
          //           onClick={() => {
          //             handledeleteClick(params.row.id);
          //           }}
          //         />
          //         )}
          //       </Stack>,
          //     ];
          //   },
          // },

          {
            field: "serialNo",
            headerName: t("text.SrNO"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 60
          },
          {
            field: "city_name",
            headerName: t("text.DistrictName"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 150
          },

          {
            field: "stateName",
            headerName: t("text.StateName"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 150
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          // border: ".5px solid #FF7722 ",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.DistrictMaster")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Stack direction="row" spacing={2} classes="my-2 mb-2">
            {permissionData?.isAdd == true && (
            <Button
              onClick={routeChangeAdd}
              variant="contained"
              endIcon={<AddCircleIcon />}
              size="large"
              style={{ backgroundColor: `var(--header-background)` }}
            >
              {t("text.add")}
            </Button>
            )} 


          </Stack>

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Box>
              <br />
              <div
                style={{
                  width: "100%",
                  backgroundColor: `var(--grid-background)`,
                }}
              >
                <DataGrid
                  rows={zones}
                  columns={adjustedColumns}
                  autoHeight
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  rowSpacingType="border"
                  pagination={true}
                  pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                    value: size,
                    label: `${size}`,
                  }))}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                />
              </div>
            </Box>
          )}
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
}
